import { Stack, useFocusEffect } from "expo-router";
import { View } from "react-native";
import SettingsTabs from "../../components/feature/settings/settings-tabs";
import { ErrorDisplay } from "../../components/common/error-display";
import { useSettingsData } from "../../contexts/SettingsDataContext";
import PageTemplate from "../../components/common/page-template";
import UnsavedChangesBanner from "../../components/feature/settings/common/unsaved-changes-banner";
import { useCallback } from "react";
import { Settings } from "lucide-react-native";

const SettingsNavigator = () => {
  const { error } = useSettingsData();

  useFocusEffect(
    useCallback(() => {
      // hide crisp chatbox on settings page
      document.body.setAttribute("data-page", "settings");
      return async () => {
        document.body.removeAttribute("data-page");
      };
    }, [])
  );

  if (error) {
    return (
      <ErrorDisplay message="We're having trouble loading your settings." />
    );
  }

  return (
    <PageTemplate title="Settings" headerIcon={Settings}>
      <View className="flex-1">
        <SettingsTabs />
        <View className="flex-1">
          <Stack
            screenOptions={{
              headerShown: false,
            }}
          />
        </View>
        <UnsavedChangesBanner />
      </View>
    </PageTemplate>
  );
};

export const SettingsLayout = () => {
  return <SettingsNavigator />;
};

export default SettingsLayout;
